// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"7ec00eea","521":"827a2136","621":"f3d9c740","641":"f3016f5a","706":"2f1b44b8"}[chunkId] + ".chunk.js";
};